import dayjs, { Dayjs } from "dayjs";
import { HrcsLocation, WindConditions } from "../types";

export const mphToKts = (mph: number): number => {
  return +(mph * 0.868976).toFixed(0);
};

export const windDirectionToCompass = (deg: number): string => {
  const directions = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
  const index = Math.round(deg / 22.5) % 16;
  return directions[index];
};

export const hasValidWindConditions = (windConditions: WindConditions, sailStart: Dayjs | null, sailLocation: HrcsLocation) => {
  const hasWindValues = windConditions.windDirection && windConditions.windGustKts > 0 && windConditions.windSpeedKts > 0;
  return hasWindValues && sailStart && Math.abs(sailStart?.diff(dayjs(), 'minute')) < 2 && sailLocation === 'Chelsea';
};
